"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityFileErrorCodes = exports.EntityFileMetaSchema = exports.EntityFileStatus = void 0;
const zod_1 = require("zod");
exports.EntityFileStatus = zod_1.z.enum(['pending', 'uploaded', 'failed', 'deleted']);
exports.EntityFileMetaSchema = zod_1.z.object({
    fileId: zod_1.z.string().uuid(),
    entityType: zod_1.z.string(),
    entityId: zod_1.z.string().uuid(),
    slot: zod_1.z.string(),
    originalName: zod_1.z.string(),
    contentType: zod_1.z.string(),
    sizeBytes: zod_1.z.number().int().nonnegative(),
    sha256: zod_1.z.string().length(64).optional(),
    status: exports.EntityFileStatus,
    version: zod_1.z.number().int().positive(),
    uploadedAt: zod_1.z.string().datetime(),
    uploadedBy: zod_1.z.string(),
    deletedAt: zod_1.z.string().datetime().optional(),
    deletedBy: zod_1.z.string().optional(),
});
exports.EntityFileErrorCodes = [
    'not_found',
    'validation_error',
    'conflict',
    'forbidden',
    'tenant_mismatch',
    'slot_limit_exceeded',
    'file_too_large',
    'invalid_content_type',
    'entity_not_found',
];
//# sourceMappingURL=entity-file-schemas.js.map